import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';
import { of } from 'rxjs/observable/of';
import { type Store } from 'redux';
import { type ActionsObservable } from 'redux-observable';
import { fetchFailed, fetchSuccess } from '../../common/fetch-request-analytics';
import { getCloudId } from '../context/selectors';
import { getProject } from '../project/selectors';
import { type ProvisioningStatus, planConfluenceActivation$ } from './requests';
import { PLAN_ACTIVATION, updateConfluenceActivationStatus } from '../actions/activate-confluence';
import { getActivationStatus } from '../activation/selectors';
import { type State } from '../types';
import { type ActivationStatus } from '../activation/types';

const provisioningStatusToActivationStatusMap: Record<ProvisioningStatus, ActivationStatus> = {
	PROVISIONING_IN_PROGRESS: 'activating',
	PROVISIONING_FAILED: 'error',
	PROVISIONING_COMPLETED: 'completed',
	PROVISIONING_PROCESS_NOT_FOUND: 'not-allowed',
};

export default (
	action$: ActionsObservable<ReturnType<typeof planConfluenceActivation$>>,
	store: Store<State>,
) =>
	action$
		.ofType(PLAN_ACTIVATION)
		.filter(() => {
			const state = store.getState();
			const activationStatus = getActivationStatus(state);
			return activationStatus === 'not-started';
		})
		.switchMap(() => {
			const state = store.getState();
			const project = getProject(state);
			const cloudId = getCloudId(state);

			return planConfluenceActivation$(cloudId, {
				projectId: project.id,
			})
				.mergeMap((response) => {
					fetchSuccess('confluence.activate.plan');
					if (response.allowed) {
						return of(
							updateConfluenceActivationStatus({
								status: 'allowed',
							}),
						);
					}
					return of(
						updateConfluenceActivationStatus({
							status:
								provisioningStatusToActivationStatusMap[
									response.context?.status || 'PROVISIONING_PROCESS_NOT_FOUND'
								],
						}),
					);
				})
				.catch((error) => {
					fetchFailed('confluence.activate.plan', error);
					return of(
						updateConfluenceActivationStatus({
							status: 'not-allowed',
						}),
					);
				});
		});
